import React from 'react';
import { Container, Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import classes from './index.module.scss';
import Promo_One from '../../../assets/images/promo-1.png';
import Promo_Two from '../../../assets/images/promo-2.jpg';
import Promo_Three from '../../../assets/images/promo-3.png';

const Advertise = () => {
  return (
    <section className={classes.Promo}>
      <Container fluid>
        <Row className="align-items-center flex-lg-row flex-column-reverse">
          <Col lg={7} className={classes.Promo_Icons_Wrap}>
            <div>
              <h3 className={classes.Promo_Title}>
                Related Websites and Services
              </h3>
            </div>
            <a target="_blank" rel="noreferrer" href="https://www.ncmbc.us/">
              <img src={Promo_One} alt="ncmbc" />
            </a>
            <a target="_blank" rel="noreferrer" href="https://deftech.nc.gov/">
              <img src={Promo_Two} alt="deftech" />
            </a>
            <a target="_blank" rel="noreferrer" href="https://www.cybernc.us/">
              <img src={Promo_Three} alt="cybernc" />
            </a>
          </Col>
          <Col lg={5} className={classes.Promo_Text_Wrap}>
            <h2 className={classes.Promo_Title}>
              Want to see<br />
              Your business here?
            </h2>
            <p className={classes.Promo_Description}>
              <b>Advertise here.</b> Contact us for information and prices.
            </p>
            <Link
              to="/contact-us"
              className="btnSizes filledBtn px-5 py-3"
            >
              Contact Us 
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default Advertise;